import { render, staticRenderFns } from "./penalize-button.vue?vue&type=template&id=7d2426c4&scoped=true&"
import script from "./penalize-button.vue?vue&type=script&lang=js&"
export * from "./penalize-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2426c4",
  null
  
)

export default component.exports